
export const getCurrentPage = state => {
  return state.currentPage
}
